export enum CategoryPriority {
    High = 1,
    Mid = 2,
    Low = 3
}
